import Vue from "vue";
import {
  Icon,
  Button,
  Input,
  Select,
  Table,
  TableColumn,
  Pagination,
  MessageBox,
  Loading,
  Radio,
  RadioButton,
  RadioGroup,
  Tabs,
  TabPane,
  Dialog,
  DatePicker,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Form,
  FormItem,
  Option,
  Steps,
  Step,
  OptionGroup,
  Notification,
  Tooltip,
  Popover,
  Switch,
  Upload,
  Image,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Popconfirm,
  Tag
} from "element-ui";
import "../theme/index.css";

Vue.use(Icon);
Vue.use(Button);
Vue.use(Input);
Vue.use(Select);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Dialog);
Vue.use(DatePicker);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Tooltip);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Loading.directive);
Vue.use(Switch);
Vue.use(Upload);
Vue.use(Image);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Popconfirm);
Vue.use(Tag);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;

import { message } from "./assets/js/resetMessage"; // 引入resetMessage
import App from "./App";
import router from "./router";
import axios from "./assets/js/axios";
import Vuex from "vuex";
import store from "./vuex/store";
import "babel-polyfill";
import common from "./assets/js/common.js";
import "./assets/icon/iconfont.css";
import echarts from "echarts";

Vue.use(Vuex);
Vue.prototype.$echarts = echarts; //引入组件
Vue.prototype.$http = axios;
Vue.prototype.$message = message;

Vue.prototype.common = common;
if (
  window.location.host == "localhost:8080" ||
  window.location.origin.indexOf("10.1.16.246") != -1
) {
  Vue.prototype.url = 'http://172.16.9.229:80'
  // Vue.prototype.url = 'https://mpstest.longsys.com'
  // Vue.prototype.url='https://www.wukoon-app.com'192.168.31.134
  // Vue.prototype.url = "https://mps.longsys.com";
} else {
  Vue.prototype.url = window.location.origin;
}
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js